import { Typography, Card, CardBody, CardHeader, Button, Badge, Avatar, Chip } from "@material-tailwind/react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';
import moment from "moment";
import { WBLabel } from "./WBLabel";
import logo from "../../assets/logo.png";
import { mappingStatus, mappingType } from "../../helper/textHelper";

function PropertyCard ({
    imgs, img, tag, date, data, title, desc, label, onClick, agent, pill, hideAgent = false
}) {
    return (
        <Card className="border">
            <CardHeader className="h-64">
                {
                    imgs &&
                        <Swiper
                            spaceBetween={30}
                            pagination={{clickable: true}}
                            modules={[Pagination]}
                        >
                            {
                                imgs.map( (value, index) => {
                                    return (
                                    <SwiperSlide key={index}>
                                        <img
                                            width={768}
                                            height={768}
                                            src={value}
                                            alt={index}
                                            className="h-full w-full object-fill scale-[1.1]"
                                        />
                                    </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                }
                {
                    img &&
                        <img
                            width={768}
                            height={768}
                            src={img}
                            alt={title}
                            className="h-full w-full object-cover scale-[1.1]"
                        />
                }
            </CardHeader>
            <CardBody className="pb-4">
                {/* <div className="flex items-center gap-2">
                    <Typography
                        variant="small"
                        className="font-normal text-gray"
                    >
                        {tag}
                    </Typography>
                </div> */}
                {
                    pill &&
                    <div className="flex gap-2 my-1">
                        <Chip className="bg-green-100 text-green-800" value={mappingType(data.listingType)}/>
                        <Chip className="bg-green-100 text-green-800" value={mappingStatus(data.listingStatus)}/>
                    </div>
                }
                <a href="#" className="text-black transition-colors hover:text-black">
                    <Typography variant="h6" className="font-bold text-ellipsis">
                        {title}
                    </Typography>
                </a>
                <Typography className="mb-2 font-normal !text-gray truncate">{desc}</Typography>
                {
                    !hideAgent && 
                    <div className="flex justify-between items-center">
                        <div>
                            {(agent || date) && <div>
                                <div className="flex items-center">
                                    <Badge placement="top-start" overlap="circular" color="green" withBorder>
                                        <Avatar size="sm" src={((agent && agent.isActive) && agent.profilePic) ? agent.profilePic : logo} alt={'avatar'}
                                            withBorder={true}
                                            className="p-0.5"
                                        />
                                    </Badge>
                                    <div className="flex-auto ml-2">
                                        <WBLabel className={"font-[11px]"} bold text={((agent && agent.isActive)  && agent.name) ? agent.name : 'Maxx Property'}/>
                                        <WBLabel className={"font-[11px]"} text={"Agent"}/>
                                    </div>
                                </div>
                                {
                                    date && <div className="text-[11px] mt-1">Posted on {moment(date).format('DD/MM/YYYY')}</div>
                                }
                            </div>}
                        </div>
                        <div className='text-right'>
                            <Button variant="outlined" onClick={() => {
                                if (onClick) { onClick() }
                            }}>{label}</Button>
                        </div>
                    </div>
                }
                {
                    hideAgent &&
                    <div className='text-right'>
                        <Button variant="outlined" onClick={() => {
                            if (onClick) { onClick() }
                        }}>{label}</Button>
                    </div>
                }
            </CardBody>
        </Card>
    )
}

export default PropertyCard